(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9846],{

/***/ 72993:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tug",
      function () {
        return __webpack_require__(73847);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 31719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



function Container(_param) {
    var children = _param.children, fluid = _param.fluid, classNameInput = _param.className, rest = _objectWithoutProperties(_param, [
        "children",
        "fluid",
        "className"
    ]);
    var className = "PingCAPContainer";
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpread({
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, classNameInput, (_obj = {}, _defineProperty(_obj, "".concat(className, "-fluid"), fluid), _defineProperty(_obj, "".concat(className, "-normal"), !fluid), _obj))
    }, rest, {
        children: children
    }));
};


/***/ }),

/***/ 75532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MyLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



function MyLink(_param) {
    var to = _param.to, href = _param.href, children = _param.children, rest = _objectWithoutProperties(_param, [
        "to",
        "href",
        "children"
    ]);
    return href ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", _objectSpread({}, rest, {
        href: href,
        target: "_blank",
        rel: "noopener noreferrer",
        children: children
    })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), _objectSpread({}, rest, {
        href: to,
        children: children
    }));
};


/***/ }),

/***/ 73847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/regex.js
/* harmony default export */ var regex = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/validate.js


function validate(uuid) {
  return typeof uuid === 'string' && regex.test(uuid);
}

/* harmony default export */ var esm_browser_validate = (validate);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!esm_browser_validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = (stringify);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v4.js



function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return esm_browser_stringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/index.js + 3 modules
var utils = __webpack_require__(59874);
// EXTERNAL MODULE: ./src/components/Container/Container.tsx
var Container = __webpack_require__(31719);
// EXTERNAL MODULE: ./src/components/people/HowToBecome/HowToBecome.module.scss
var HowToBecome_module = __webpack_require__(4609);
var HowToBecome_module_default = /*#__PURE__*/__webpack_require__.n(HowToBecome_module);
// EXTERNAL MODULE: ./src/components/MyLink.jsx
var MyLink = __webpack_require__(75532);
;// CONCATENATED MODULE: ./src/components/people/HowToBecome/HowToBecome.jsx




function HowToBecome(param) {
    var index = param.index, iconUrl = param.iconUrl, title = param.title, link = param.link;
    var innerDom = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HowToBecome_module_default()).index,
                children: index
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HowToBecome_module_default()).avatar,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: iconUrl,
                    alt: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HowToBecome_module_default()).title,
                children: title
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (HowToBecome_module_default()).wrapper,
        children: link ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MyLink/* default */.Z, {
            href: link,
            children: innerDom
        }) : innerDom
    });
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/people/TMCItem/TMCItem.module.scss
var TMCItem_module = __webpack_require__(32101);
var TMCItem_module_default = /*#__PURE__*/__webpack_require__.n(TMCItem_module);
;// CONCATENATED MODULE: ./src/components/people/TMCItem/TMCItem.jsx





function TMCItem(param) {
    var name = param.name, role = param.role, company = param.company, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (TMCItem_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TMCItem_module_default()).avatar,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    unoptimized: true,
                    src: utils/* cdn.getImageUrl */.cK.getImageUrl("/images/avatar/".concat(encodeURIComponent(name), ".jpg")),
                    alt: name,
                    width: 150,
                    height: 150
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TMCItem_module_default()).name,
                children: name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TMCItem_module_default()).role,
                children: role
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (TMCItem_module_default()).metadata,
                children: [
                    company,
                    " ",
                    title
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/pages/tug/index.module.scss
var index_module = __webpack_require__(50562);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/pages/tug/tug.data.js

var data = {
    tmc: [
        {
            avatar: "",
            name: "\u623F\u6653\u4E50",
            company: "PingCAP",
            title: "\u4E92\u8054\u7F51\u9996\u5E2D\u67B6\u6784\u5E08"
        },
        {
            avatar: "",
            name: "\u9EC4\u6F47",
            company: "\u7F8E\u56E2",
            title: "DBA"
        }, 
    ],
    leader: [
        {
            avatar: "",
            name: "\u5218\u6625\u96F7",
            company: "58 \u540C\u57CE",
            title: "DBA",
            role: "\u5185\u5BB9\u7EC4 Leader"
        },
        {
            avatar: "",
            name: "\u5F90\u5609\u57E5",
            company: "\u5EFA\u4FE1\u91D1\u79D1",
            title: "\u6570\u636E\u5E93\u7814\u53D1",
            role: "\u5185\u5BB9\u7EC4 Co-Leader"
        },
        {
            avatar: "",
            name: "\u738B\u5FD7\u5E7F",
            company: "bilibili",
            title: "DBA",
            role: "\u5185\u5BB9\u7EC4 Co-Leader"
        },
        {
            avatar: "",
            name: "\u7530\u670B",
            company: "\u4EAC\u4E1C\u79D1\u6280",
            title: "DBA",
            role: "\u5BA3\u4F20\u7EC4 Co-Leader"
        },
        {
            avatar: "",
            name: "\u80E1\u56FD\u9752",
            company: "",
            title: "\u6570\u636E\u5E93\u8BB2\u5E08",
            role: "\u5BA3\u4F20\u7EC4 Co-Leader"
        },
        {
            avatar: "",
            name: "\u4EE3\u6653\u78CA",
            company: "360",
            title: "\u667A\u6167\u5546\u4E1A\u6570\u636E\u5E93\u8FD0\u7EF4\u9AD8\u7EA7\u4E13\u5BB6",
            role: "\u534E\u5317\u7EC4 Leader"
        },
        {
            avatar: "",
            name: "\u9773\u732E\u65D7",
            company: "\u6C7D\u8F66\u4E4B\u5BB6",
            title: "\u9AD8\u7EA7 DBA",
            role: "\u534E\u5317\u7EC4 Co-Leader"
        },
        {
            avatar: "",
            name: "\u8D75\u6D77\u519B",
            company: "\u7406\u60F3\u6C7D\u8F66",
            title: "\u6570\u636E\u5E93\u8D1F\u8D23\u4EBA",
            role: "\u534E\u5317\u7EC4 Co-Leader"
        },
        {
            avatar: "",
            name: "\u95EB\u6653\u5B87",
            company: "\u5F97\u7269",
            title: "DBA Leader",
            role: "\u534E\u4E1C\u7EC4 Leader"
        },
        {
            avatar: "",
            name: "\u7F57\u745E\u661F",
            company: "\u767E\u80DC\u4E2D\u56FD",
            title: "IT \u5927\u6570\u636E\u7ECF\u7406",
            role: "\u534E\u4E1C\u7EC4 Co-Leader"
        },
        {
            avatar: "",
            name: "\u6768\u6F06",
            company: "\u592A\u5E73\u4EBA\u5BFF\u4FDD\u9669\u603B\u516C\u53F8",
            title: "\u5173\u7CFB\u578B\u6570\u636E\u5E93\u7BA1\u7406\u5C97",
            role: "\u534E\u4E1C\u7EC4 Co-Leader"
        },
        {
            avatar: "",
            name: "\u5510\u4E07\u6C11",
            company: "\u591A\u70B9",
            title: "RDBMS \u6570\u636E\u5E93\u7EC4\u8D1F\u8D23\u4EBA",
            role: "\u897F\u5357\u7EC4 Leader"
        },
        {
            avatar: "",
            name: "\u80E1\u76FC\u76FC",
            company: "\u5FAE\u4F17\u94F6\u884C",
            title: "\u6570\u636E\u5E93\u5E73\u53F0\u8D1F\u8D23\u4EBA",
            role: "\u534E\u5357\u7EC4 Leader"
        },
        {
            avatar: "",
            name: "\u7530\u7EF4\u7E41",
            company: "\u7F51\u6613\u6E38\u620F",
            title: "DBA",
            role: "\u534E\u5357\u7EC4 Co-Leader"
        },
        {
            avatar: "",
            name: "\u9EC4\u851A",
            company: "\u5FAE\u4F17\u94F6\u884C",
            title: "\u9AD8\u7EA7 DBA",
            role: "\u534E\u5357\u7EC4 Co-Leader"
        },
        {
            avatar: "",
            name: "Neil Han",
            company: "PingCAP",
            title: "Head of APAC",
            role: "APAC \u533A\u57DF\u7EC4 Leader"
        }, 
    ],
    adviser: [
        {
            avatar: "",
            name: "\u5B59\u6653\u5149",
            company: "PingCAP Community Development",
            title: "\u56E2\u961F\u8D1F\u8D23\u4EBA",
            role: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "TUG 2019 \u5317\u4EAC\u533A Leader",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "TUG \u987E\u95EE\u56E2\u6210\u5458"
                ]
            })
        },
        {
            avatar: "",
            name: "\u4FAF\u5723\u6587",
            company: "\u8D1D\u58F3\u627E\u623F",
            title: "\u57FA\u7840\u5E73\u53F0\u603B\u76D1",
            role: "TUG \u987E\u95EE\u56E2\u6210\u5458"
        },
        {
            avatar: "",
            name: "\u8D3E\u4E16\u95FB",
            company: "\u4EAC\u4E1C\u4E91",
            title: "\u4EA4\u4ED8\u90E8\u67B6\u6784\u5E08",
            role: "TUG \u987E\u95EE\u56E2\u6210\u5458"
        },
        {
            avatar: "",
            name: "\u8D75\u4ED5\u5E86",
            company: "\u4EAC\u4E1C\u79D1\u6280",
            title: "\u7814\u53D1\u5DE5\u7A0B\u5E08",
            role: "TUG \u987E\u95EE\u56E2\u6210\u5458"
        },
        {
            avatar: "",
            name: "\u4EE3\u6653\u78CA",
            company: "360",
            title: "\u667A\u6167\u5546\u4E1A\u6570\u636E\u5E93\u8FD0\u7EF4\u9AD8\u7EA7\u4E13\u5BB6",
            role: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "TUG \u987E\u95EE\u56E2\u6210\u5458",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "\u534E\u5317\u7EC4 Leader"
                ]
            })
        }, 
    ]
};
/* harmony default export */ var tug_data = (data);

// EXTERNAL MODULE: ./src/layouts/index.js + 13 modules
var layouts = __webpack_require__(59269);
// EXTERNAL MODULE: ./src/components/index.js + 20 modules
var components = __webpack_require__(21679);
// EXTERNAL MODULE: ./src/components/home/HomeMVA/HomeMVA.module.scss
var HomeMVA_module = __webpack_require__(42);
var HomeMVA_module_default = /*#__PURE__*/__webpack_require__.n(HomeMVA_module);
;// CONCATENATED MODULE: ./src/components/home/HomeMVA/HomeMVA.jsx








function HomeMVA() {
    var router = (0,next_router.useRouter)();
    var onClick = function(link) {
        return function(e) {
            e.preventDefault();
            utils/* link.handleRedirect */.p4.handleRedirect(router, link);
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (HomeMVA_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                className: (HomeMVA_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HomeMVA_module_default()).title,
                        children: "2020 \u5E74\u5EA6 TUG MVA"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HomeMVA_module_default()).summary,
                        children: "TUG MVA (Most Valuable Advocate) \u901A\u8FC7\u5206\u4EAB\u4F18\u8D28\u7684\u6280\u672F\u5185\u5BB9\uFF0C\u5E2E\u52A9\u5927\u5BB6\u66F4\u597D\u5730\u4F7F\u7528 TiDB\uFF0C\u662F\u7ECF\u8FC7\u8BA4\u8BC1\u7684\u6280\u672F\u5148\u950B\uFF0C\u4EAB\u53D7\u6781\u9AD8\u7684\u793E\u533A\u8363\u8A89\u3002"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HomeMVA_module_default()).buttons,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                            type: "primary",
                            onClick: onClick("/tug/mva"),
                            children: "\u67E5\u770B\u66F4\u591A"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HomeMVA_module_default()).image,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    unoptimized: true,
                    src: utils/* cdn.getImageUrl */.cK.getImageUrl("/images/tug/home-mva.png"),
                    alt: "",
                    width: 2733 / 2,
                    height: 360 / 2
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/tug/index.page.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}















var getImageUrl = function(filename) {
    return utils/* cdn.getImageUrl */.cK.getImageUrl("/images/people/" + filename);
};
var title = "TiDB User Group \u4F1A\u5458";
var description = "TUG(TiDB User Group) \u4E3A TiDB \u7528\u6237\u63D0\u4F9B\u4E86\u4E00\u4E2A\u5F00\u653E\u7684\u4EA4\u6D41\u5E73\u53F0\u3002\u6210\u5458\u4EEC\u79EF\u6781\u5728\u793E\u533A\u4E2D\u8D21\u732E\u4E86\u5927\u91CF\u4F18\u8D28\u7684\u5185\u5BB9\uFF0C\u65E2\u6269\u5927\u4E86 TUG \u7684\u5F71\u54CD\u529B\uFF0C\u4E5F\u4ECE\u4E2D\u6536\u83B7\u5F88\u591A\u4EF7\u503C\uFF0C\u5F62\u6210\u4E86\u201C\u6765\u81EA\u793E\u533A\uFF0C\u56DE\u9988\u793E\u533A\u201D \u7684\u826F\u6027\u5FAA\u73AF\u3002";
var applyUrl = "/tug/apply#form";
var tugOrganizationChartTitle = "TUG \u7EC4\u7EC7\u67B6\u6784";
var tugOrganizationChartUrl = getImageUrl("tug-organization-chart.svg");
var howToBecomeTitle = "\u5982\u4F55\u6210\u4E3A TUG \u4F1A\u5458";
var howToBecome = [
    {
        index: 1,
        iconUrl: getImageUrl("how-to-become-1.svg"),
        title: "\u586B\u5199\u4FE1\u606F",
        link: applyUrl
    },
    {
        index: 2,
        iconUrl: getImageUrl("how-to-become-2.svg"),
        title: "\u4FE1\u606F\u5BA1\u6838"
    },
    {
        index: 3,
        iconUrl: getImageUrl("how-to-become-3.svg"),
        title: "\u9080\u8BF7\u52A0\u5165"
    }, 
];
var progressTitle = "TUG \u4F1A\u5458\u8FDB\u9636\u8DEF\u7EBF";
var progressSummary = "TUG \u6838\u5FC3\u6210\u5458\u5305\u62EC TUG \u7BA1\u7406\u6210\u5458\u3001Active Ambassador\u3001Ambassador\u3002" + "\u79EF\u6781\u6D3B\u8DC3\u7684 TUG \u6210\u5458\u53EF\u88AB\u63D0\u540D\u4E3A Ambassador\uFF0CAmbassador \u5728\u793E\u533A\u8D21\u732E\u4F18\u8D28\u5185\u5BB9\u53EF\u5347\u7EA7\u4E3A \u201CActive Ambassador\u201D \u4E4B\u540E\u6709\u4E24\u79CD\u4E0D\u540C\u7684\u53D1\u5C55\u65B9\u5411\u3002";
var progressStep1 = "\u7BA1\u7406\u7EBF\uFF1A\u4E0A\u5347\u901A\u9053\u4E3A TUG \u7BA1\u7406\u6210\u5458\uFF0C\u5305\u62EC Team Co-Leader\u3001Team Leader\u3001TMC \u6210\u5458\u3002TUG \u7BA1\u7406\u6210\u5458\u4EFB\u671F\u4E3A\u4E00\u5E74\u3002" + "TMC \u6210\u5458\u3001Team Leader \u6BCF\u5E74\u901A\u8FC7\u6362\u5C4A\u9009\u4E3E\u4EA7\u751F\uFF0CTeam Co-Leader \u5728\u6362\u5C4A\u9009\u4E3E\u540E\u7531 TeamLeader \u8FDB\u884C\u59D4\u4EFB\u3002";
var progressStep2 = "\u4E13\u4E1A\u7EBF\uFF1A\u4E0A\u5347\u901A\u9053\u4E3A TiDB MVA (Most Valuable Advocate)\uFF0C\u6216\u8005\u66F4\u9AD8\u7EA7\u522B\u7684 TiDB MOA (Most OutstandingAdvocate)\u3002";
var peopleMemberTitle = "TMC \u6210\u5458";
var peopleMemberSummary = "TMC \u662F TUG \u6700\u9AD8\u51B3\u7B56\u7EC4\u7EC7\uFF0C\u8D1F\u8D23\u7EDF\u7B79 TUG \u53D1\u5C55\u4E0E\u89C4\u5212\u3001\u91CD\u8981\u4EBA\u4E8B\u4EFB\u514D\u3001\u5168\u5E74\u5927\u4E8B\u5B89\u6392\u7B49";
var peopleLeaderTitle = "LEADER";
var peopleLeaderSummary = "TUG \u5404\u533A\u57DF\u8D1F\u8D23\u4EBA\uFF0C\u8D1F\u8D23\u7EDF\u7B79\u672C\u533A\u57DF\u5185TUG \u7684\u53D1\u5C55\u4EE5\u53CA\u6D3B\u52A8\u89C4\u5212";
var peopleAdviserTitle = "\u987E\u95EE\u56E2";
var peopleAdviserSummary = "TUG \u7279\u9080\u987E\u95EE\uFF0C\u62E5\u6709\u8BF8\u591A\u6280\u672F\u7ECF\u9A8C\uFF0C\u8D1F\u8D23\u5E2E\u52A9\u89E3\u7B54 TUG \u4E2D\u6280\u672F\u95EE\u9898";
var Tug = function() {
    var tmc = tug_data.tmc, leader = tug_data.leader, adviser = tug_data.adviser;
    var router = (0,next_router.useRouter)();
    var onClick = function(link) {
        return function(e) {
            e.preventDefault();
            utils/* link.handleRedirect */.p4.handleRedirect(router, link);
        };
    };
    var howToBecomeDom = [];
    howToBecome.forEach(function(item, index) {
        howToBecomeDom.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(HowToBecome, _objectSpread({}, item), esm_browser_v4()));
        if (index !== howToBecome.length - 1) {
            howToBecomeDom.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (index_module_default()).how_to_become_list_arrow,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: getImageUrl("arrow.svg"),
                    alt: ">"
                })
            }, esm_browser_v4()));
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CommunityHead */.Wh, {
                title: title,
                description: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* CoreLayout */.N, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (index_module_default()).header,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (index_module_default()).header_content,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (index_module_default()).header_content_left,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (index_module_default()).header_content_left_title,
                                                children: "TUG \u4F1A\u5458"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (index_module_default()).header_content_left_summary,
                                                children: description
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (index_module_default()).header_content_left_summary,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                                    type: "primary",
                                                    onClick: onClick(applyUrl),
                                                    children: "\u52A0\u5165 TUG"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (index_module_default()).header_content_right,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            width: 400,
                                            src: getImageUrl("header-right.png"),
                                            alt: ""
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        className: (index_module_default()).organization_chart,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (index_module_default()).organization_chart_content,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (index_module_default()).organization_chart_content_title,
                                    children: tugOrganizationChartTitle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (index_module_default()).organization_chart_content_image,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MyLink/* default */.Z, {
                                        href: tugOrganizationChartUrl,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: tugOrganizationChartUrl,
                                            alt: tugOrganizationChartTitle
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (index_module_default()).how_to_become_wrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                            className: (index_module_default()).how_to_become,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (index_module_default()).how_to_become_title,
                                    children: howToBecomeTitle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (index_module_default()).how_to_become_list,
                                    children: howToBecomeDom
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                        className: (index_module_default()).progress,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (index_module_default()).progress_left,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (index_module_default()).progress_left_header,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (index_module_default()).progress_left_header_icon,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: getImageUrl("progress-header-left.svg"),
                                                    alt: ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (index_module_default()).progress_left_header_text,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (index_module_default()).progress_left_header_text_title,
                                                        children: progressTitle
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (index_module_default()).progress_left_header_text_summary,
                                                        children: progressSummary
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (index_module_default()).progress_left_step,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (index_module_default()).progress_left_step_1,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (index_module_default()).progress_left_step_1_header,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (index_module_default()).progress_left_step_1_header_index,
                                                                children: "1"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (index_module_default()).progress_left_step_1_header_widget,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: getImageUrl("progress-widget-1.svg"),
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (index_module_default()).progress_left_step_1_text,
                                                        children: progressStep1
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (index_module_default()).progress_left_step_2,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (index_module_default()).progress_left_step_2_header,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (index_module_default()).progress_left_step_2_header_index,
                                                                children: "2"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (index_module_default()).progress_left_step_2_header_widget,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: getImageUrl("progress-widget-2.svg"),
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (index_module_default()).progress_left_step_2_text,
                                                        children: progressStep2
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (index_module_default()).progress_right,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (index_module_default()).progress_right_icon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: getImageUrl("progress-header-right.svg"),
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (index_module_default()).progress_right_chart,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: getImageUrl("progress-chart.svg"),
                                            alt: ""
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (index_module_default()).people,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                            className: (index_module_default()).people_content,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (index_module_default()).people_content_title,
                                    children: peopleMemberTitle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (index_module_default()).people_content_summary,
                                    children: peopleMemberSummary
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (index_module_default()).people_content_list,
                                    children: tmc.map(function(item, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TMCItem, _objectSpread({}, item), index);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (index_module_default()).people_content_split
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (index_module_default()).people_content_title,
                                    children: peopleLeaderTitle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (index_module_default()).people_content_summary,
                                    children: peopleLeaderSummary
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (index_module_default()).people_content_list,
                                    children: leader.map(function(item, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TMCItem, _objectSpread({}, item), index);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (index_module_default()).people_content_split
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (index_module_default()).people_content_title,
                                    children: peopleAdviserTitle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (index_module_default()).people_content_summary,
                                    children: peopleAdviserSummary
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (index_module_default()).people_content_list,
                                    children: adviser.map(function(item, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TMCItem, _objectSpread({}, item), index);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeMVA, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var index_page = (Tug);


/***/ }),

/***/ 42:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HomeMVA_wrapper__0K3LE","container":"HomeMVA_container___EktG","title":"HomeMVA_title__4PHTk","summary":"HomeMVA_summary__wuvdD","buttons":"HomeMVA_buttons__RCU2T","image":"HomeMVA_image__2SCsQ"};

/***/ }),

/***/ 4609:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HowToBecome_wrapper__0yOus","index":"HowToBecome_index__AFVLk","title":"HowToBecome_title__3yiOz"};

/***/ }),

/***/ 32101:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TMCItem_wrapper__WdLaf","avatar":"TMCItem_avatar__7Cncw","name":"TMCItem_name__nhwx6","role":"TMCItem_role__2gGI1","metadata":"TMCItem_metadata__CAfmd"};

/***/ }),

/***/ 50562:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"tug_header__cWChm","header_content":"tug_header_content__APeZ2","header_content_left":"tug_header_content_left__r4Cp_","header_content_left_title":"tug_header_content_left_title__0_7FF","header_content_left_summary":"tug_header_content_left_summary__AP5b2","header_content_right":"tug_header_content_right__dzqoC","organization_chart_content":"tug_organization_chart_content__rOcRw","organization_chart_content_title":"tug_organization_chart_content_title__epLyR","organization_chart_content_image":"tug_organization_chart_content_image__SJ0R3","how_to_become_wrapper":"tug_how_to_become_wrapper__cI0pt","how_to_become":"tug_how_to_become__SbjkG","how_to_become_title":"tug_how_to_become_title__AUk8i","how_to_become_list":"tug_how_to_become_list__kRXiC","how_to_become_list_arrow":"tug_how_to_become_list_arrow__Yt_yZ","progress":"tug_progress__LGNCS","progress_left":"tug_progress_left__MJFa5","progress_left_header":"tug_progress_left_header__EakD4","progress_left_header_text":"tug_progress_left_header_text__1upt2","progress_left_header_text_title":"tug_progress_left_header_text_title__UsEv8","progress_left_header_text_summary":"tug_progress_left_header_text_summary__dZXhI","progress_left_step_1":"tug_progress_left_step_1__mqrSR","progress_left_step_1_header":"tug_progress_left_step_1_header__JpXyY","progress_left_step_1_header_index":"tug_progress_left_step_1_header_index__4y2St","progress_left_step_1_header_widget":"tug_progress_left_step_1_header_widget__nOQBK","progress_left_step_1_text":"tug_progress_left_step_1_text__r8NMX","progress_left_step_2":"tug_progress_left_step_2__PQ_nj","progress_left_step_2_header":"tug_progress_left_step_2_header___64ks","progress_left_step_2_header_index":"tug_progress_left_step_2_header_index__0osQ4","progress_left_step_2_header_widget":"tug_progress_left_step_2_header_widget__ll1x_","progress_left_step_2_text":"tug_progress_left_step_2_text__Prfvg","progress_right":"tug_progress_right__Tu5ZO","progress_right_chart":"tug_progress_right_chart__KFoUv","people":"tug_people__9oQWT","people_content":"tug_people_content__ncs4y","people_content_title":"tug_people_content_title__lzgn1","people_content_summary":"tug_people_content_summary__Nd8vT","people_content_list":"tug_people_content_list__b7ZHL","people_content_split":"tug_people_content_split__X6h_d"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,9774,2888,179], function() { return __webpack_exec__(72993); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);